'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DepositTracker = undefined;

var _reactRedux = require('react-redux');

var _uiTranslations = require('@wh/ui-translations');

var _actions = require('../../actions');

var _selectors = require('../../selectors');

var _DepositTracker = require('./DepositTracker');

var getApplePayLimits = function getApplePayLimits(activeCard) {
  return activeCard && activeCard.info && activeCard.info.validation || { minDepAmt: '0.00', maxDepAmt: '0.00' };
};

var DepositTracker = exports.DepositTracker = (0, _reactRedux.connect)(function (state) {
  var isApplePayAvailable = (0, _selectors.getIsApplePayAvailable)(state);
  var activeCard = (0, _selectors.activeCardSelector)(state);
  var minDeposit = isApplePayAvailable ? getApplePayLimits(activeCard).minDepAmt : activeCard.get('pmtMinAmt');
  var maxDeposit = isApplePayAvailable ? getApplePayLimits(activeCard).maxDepAmt : activeCard.get('pmtMaxAmt');

  return {
    minDeposit: minDeposit,
    maxDeposit: maxDeposit,
    currencyCode: (0, _selectors.currencyCodeSelector)(state)
  };
}, { closeQuickDeposit: function closeQuickDeposit() {
    return (0, _actions.closingComponent)();
  } })((0, _uiTranslations.withTranslator)(_DepositTracker.DepositTracker));